<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.doctransp_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Trechos
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.doctransp_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Historico
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData.doc_transp_doc_carga.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.doctransp_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Notas Fiscais
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData.doc_transp_doc_ant.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.doctransp_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos anteriores
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.doctransp_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Informações ERP
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t6' + rowData.doctransp_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Informações Conferência
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.doctransp_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 16%">Carga</th>
                <th style="width: 16%">N ° do Trecho</th>
                <th style="width: 16%">Valor do Trecho</th>
                <th style="width: 16%">Qtde. Nfs</th>
                <th style="width: 16%">Cte</th>
                <th style="width: 16%">Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.auditoria_frete
                  .pedido_unidade_carga_trecho_audit"
              >
                <td>
                  {{
                    item.pedido_unidade_carga_trecho.num_carga
                  }}
                </td>
                <td>
                  {{ item.pedido_unidade_carga_trecho.num_trecho }}
                </td>
                <td>
                  {{ item.pedido_unidade_carga_trecho.vlr_custo }}
                </td>
                <td>
                  <span>
                    {{
                      item.pedido_unidade_carga_trecho.qtde_nfs
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedido_unidade_carga_trecho.doc_cte_numero !=
                      null
                    "
                  >
                    {{
                      item.pedido_unidade_carga_trecho.doc_cte_numero
                    }}
                  </span>
                </td>
                <td>
                  <span v-if="item.pedido_unidade_carga_trecho.param_motivo">
                    {{
                      item.pedido_unidade_carga_trecho.param_motivo.descr
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.doctransp_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">N ° do Trecho</th>
                <th style="width: 20%">Valor do Trecho</th>
                <th style="width: 20%">Cte</th>
                <th style="width: 20%">Valor do Doc</th>
                <th style="width: 20%">Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.auditoria_frete
                  .pedido_unidade_carga_trecho_audit"
                v-if="item.dt_del != null"
              >
                <td>
                  <span v-if="item.dt_del != null">
                    {{ item.pedido_unidade_carga_trecho.num_trecho }}
                  </span>
                </td>
                <td>
                  <span v-if="item.dt_del != null">
                    {{
                      item.pedido_unidade_carga_trecho
                        .pedido_unidade_carga_tre_custo[0].vlr_custo
                    }}
                  </span>
                </td>
                <td>
                  <span v-if="item.dt_del != null">
                    {{
                      item.pedido_unidade_carga_trecho.pedido_unidade_carga[0]
                        .carga_doc_unidade_carga[0].carga_doc.doc_carga_doc.doc
                        .num_fiscal
                    }}
                  </span>
                </td>
                <td>
                  <span v-if="item.dt_del != null">
                    {{
                      item.pedido_unidade_carga_trecho.pedido_unidade_carga[0]
                        .carga_doc_unidade_carga[0].carga_doc[0].doc_carga_doc
                        .doc.vlr_receber
                    }}
                  </span>
                </td>
                <td>
                  <span v-if="item.dt_del != null && item.param_motivo != null">
                    {{
                      item.param_motivo.descr
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t3' + rowData.doctransp_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">N ° fiscal</th>
                <th style="width: 20%">Série</th>
                <th style="width: 20%">Chave de acesso</th>
                <th style="width: 20%">Dt Emissão</th>
                <th style="width: 20%">Valor total da NF</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.doc_transp_doc_carga"
              >
                <td>
                  <span>
                    {{ item.num_nf }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ item.serie }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ item.chave }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ DateFormat(item.dt_emi) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.vlr_total_nf != null">
                    {{ item.vlr_total_nf }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t4' + rowData.doctransp_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 100%">Chave</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in rowData.doc_transp_doc_ant">
                <tr
                  class="bg-gray-light"
                  style="display: table-row"
                  v-for="item2 in item.doc_transp_doc_ant_eletr"
                >
                  <td>
                    {{ item2.chave }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t5' + rowData.doctransp_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Status enviado ERP</th>
                <th style="width: 5%">Dt enviado ERP</th>
                <th style="width: 5%">Dt retorno ERP</th>
                <th style="width: 10%">Motivo rejeição</th>
                <th style="width: 10%">Status retorno ERP</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.status.descr }}
                </td>
                <td>
                  {{ DateFormat(rowData.dt_envio_erp) }}
                </td>
                <td>
                  {{ DateFormat(rowData.dt_processamento) }}
                </td>
                <td>
                  <span v-if="rowData.motivo_rejeicao != null">
                    {{ rowData.motivo_rejeicao }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.status_integracao != null">
                    {{ rowData.status_integracao.descr }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t6' + rowData.doctransp_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Dt Conferência</th>
                <th style="width: 10%">Usu.Conferência</th>
                <th style="width: 5%">Dt Aprovação</th>
                <th style="width: 10%">Usu.Aprovação</th>
                <th style="width: 5%">Dt Reprovação</th>
                <th style="width: 10%">Usu.Reprovação</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ DateFormat(rowData.auditoria_frete.dt_conferencia) }}
                </td>
                <td>
                  <span
                    v-if="rowData.auditoria_frete.usuario_conferencia != null"
                  >
                    {{ rowData.auditoria_frete.usuario_conferencia.email }}
                  </span>
                </td>
                <td>
                  {{ DateFormat(rowData.auditoria_frete.dt_aprovacao) }}
                </td>
                <td>
                  <span
                    v-if="rowData.auditoria_frete.usuario_aprovacao != null"
                  >
                    {{ rowData.auditoria_frete.usuario_aprovacao.email }}
                  </span>
                </td>
                <td>
                  {{ DateFormat(rowData.auditoria_frete.dt_reprovado) }}
                </td>
                <td>
                  <span
                    v-if="rowData.auditoria_frete.usuario_reprovacao != null"
                  >
                    {{ rowData.auditoria_frete.usuario_reprovacao.email }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import moment from "moment";

export default {
  data() {
    return {
      helpForm: new Form({ recordCollection: [], status: "" }),
      cnpj_formatado: "",
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onEditDoc(data) {
      this.$refs.vinculardocumentounidadeform.onEdit(data);
    },
    onEditConta(data) {
      this.$refs.vincularcontaunidadeform.onEdit(data);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
  },
};
</script>
